import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SidebarProvider } from './contexts/SidebarContext';
import { SecondarySidebarProvider } from './contexts/SecondarySidebarContext';
import { SplashProvider } from './contexts/SplashContext';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/Common/ProtectedRoute';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/custom.css';
import GearLoader from './components/Loading/GearLoader';

import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Companies from './pages/Companies/Companies';
import Adminroles from './pages/Adminroles/Adminroles';
import Adminusers from './pages/Adminusers/Adminusers';

import ProfilesEdit from './pages/Profiles/edit';
import Suppliers from './pages/Suppliers/Suppliers';
import Items from './pages/Items/Items';
import Productioncharges from './pages/Productioncharges/Productioncharges';
import Tailors from './pages/Tailors/Tailors';
import Cuttingmasters from './pages/Cuttingmasters/Cuttingmasters';
import Categories from './pages/Categories/Categories';
import Subcategories from './pages/Subcategories/Subcategories';
import Measurementunits from './pages/Measurementunits/Measurementunits';
import Postinggroups from './pages/Postinggroups/Postinggroups';
import Vatgroups from './pages/Vatgroups/Vatgroups';
import Locations from './pages/Locations/Locations';
import Customerlocations from './pages/Customerlocations/Customerlocations';
import Currencies from './pages/Currencies/Currencies';

import Customers from './pages/Customers/Customers';
import CustomersCreate from './pages/Customers/create';
import CustomersEdit from './pages/Customers/edit';

import PurchaseinvoicesCreate from './pages/Purchaseinvoices/create';
import PurchaseinvoicesEdit from './pages/Purchaseinvoices/edit';
import Purchaseinvoices from './pages/Purchaseinvoices/Purchaseinvoices';

import Jobenquiries from './pages/Jobenquiries/Jobenquiries';
import JobordersCreate from './pages/Joborders/create';
import JobordersEdit from './pages/Joborders/edit';
import Joborders from './pages/Joborders/Joborders';
import JobordersView from './pages/Joborders/view';

import JoborderlposCreate from './pages/Joborderlpos/create';
import JoborderlposEdit from './pages/Joborderlpos/edit';
import Joborderlpos from './pages/Joborderlpos/Joborderlpos';
import JoborderlposView from './pages/Joborderlpos/view';
import JoborderlposFileViewer from './pages/Joborderlpos/fileViewer';

import StockissuesCreate from './pages/Stockissues/create';
import StockissuesEdit from './pages/Stockissues/edit';
import Stockissues from './pages/Stockissues/Stockissues';
import Stockadjustments from './pages/Stockadjustments/Stockadjustments';
import Dailyproductions from './pages/Dailyproductions/Dailyproductions';
import Produceditems from './pages/Produceditems/Produceditems';

import JobcostingsCreate from './pages/Jobcostings/create';
import JobcostingsEdit from './pages/Jobcostings/edit';
import Jobcostings from './pages/Jobcostings/Jobcostings';

import CashmemosCreate from './pages/Cashmemos/create';
import CashmemosEdit from './pages/Cashmemos/edit';
import Cashmemos from './pages/Cashmemos/Cashmemos';
import CashmemosView from './pages/Cashmemos/view';

import CashmemodirectsCreate from './pages/Cashmemodirects/create';
import CashmemodirectsEdit from './pages/Cashmemodirects/edit';
import Cashmemodirects from './pages/Cashmemodirects/Cashmemodirects';
import CashmemodirectsView from './pages/Cashmemodirects/view';

import DeliverynotesCreate from './pages/Deliverynotes/create';
import DeliverynotesEdit from './pages/Deliverynotes/edit';
import Deliverynotes from './pages/Deliverynotes/Deliverynotes';
import DeliverynotesView from './pages/Deliverynotes/view';

import SaleinvoicesCreate from './pages/Saleinvoices/create';
import SaleinvoicesEdit from './pages/Saleinvoices/edit';
import Saleinvoices from './pages/Saleinvoices/Saleinvoices';
import SaleinvoicesView from './pages/Saleinvoices/view';

import CashreceiptsCreate from './pages/Cashreceipts/create';
import CashreceiptsEdit from './pages/Cashreceipts/edit';
import Cashreceipts from './pages/Cashreceipts/Cashreceipts';

import Reportpurchaseregisters from './pages/Reportpurchaseregisters/Reportpurchaseregisters';
import Reportorderstatuses from './pages/Reportorderstatuses/Reportorderstatuses';
import Reportitemproductions from './pages/Reportitemproductions/Reportitemproductions';
import Reportitemproductioncostings from './pages/Reportitemproductioncostings/Reportitemproductioncostings';
import Reporttailorworks from './pages/Reporttailorworks/Reporttailorworks';
import Reportjobordercustomerlocations from './pages/Reportjobordercustomerlocations/Reportjobordercustomerlocations';
import Reportjoborders from './pages/Reportjoborders/Reportjoborders';
import Reportsales from './pages/Reportsales/Reportsales';
import Reportdeliverynotes from './pages/Reportdeliverynotes/Reportdeliverynotes';
import Reportstockledgers from './pages/Reportstockledgers/Reportstockledgers';
import Reportitemledgers from './pages/Reportitemledgers/Reportitemledgers';
import Reportdailytransactions from './pages/Reportdailytransactions/Reportdailytransactions';

import XeroSettings from './pages/Settings/Xero/index';
import XeroRedirect from './pages/Settings/Xero/Redirect';
import GeneralSettings from './pages/Settings/General/index';

import ZohoSettings from './pages/Settings/Zoho/index';
import ZohoRedirect from './pages/Settings/Zoho/Redirect';

import Pushnotifications from './pages/Pushnotifications/Pushnotifications';


// Add future flag configuration
const router = {
    future: {
        v7_startTransition: true,
            v7_relativeSplatPath: true
        }
    };

const App = () => {
    const { isAuthenticated } = useSelector((state) => state.auth);
    const { initialized, loading, error, data: splashData } = useSelector((state) => state.splash);
    const defaultTitleRef = useRef(document.title);

    useEffect(() => {
        const dynamicTitle = splashData?.title;
        document.title = dynamicTitle || defaultTitleRef.current;
    }, [splashData?.title]);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <GearLoader />
            </div>
        );
    }

    if (error) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                color: 'red'
            }}>
                <div>Error loading application settings: {error}</div>
            </div>
        );
    }

    if (!initialized) {
        return null;
    }

    return (
        <SplashProvider splashData={splashData}>
            <Router {...router}>
                <SidebarProvider>
                    <SecondarySidebarProvider>
                        <Routes>
                            {/* Public routes */}
                            <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />

                            {/* Protected routes */}
                            <Route
                                path="/"
                                element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}
                            >
                                <Route path="companies" element={<Companies />} />
                                <Route path="notifications" element={<Pushnotifications />} />
                                <Route index element={<Dashboard />} />
 


                                {/* Purchase Routes */}
                                <Route path="categories" 
                                    element={
                                        <ProtectedRoute permissions={['view categories']}>
                                            <Categories />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="sub_categories" 
                                    element={
                                        <ProtectedRoute permissions={['view sub categories']}>
                                            <Subcategories />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="items" 
                                    element={
                                        <ProtectedRoute permissions={['view items']}>
                                            <Items />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="suppliers" 
                                    element={
                                        <ProtectedRoute permissions={['view suppliers']}>
                                            <Suppliers />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="purchase_invoices/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view purchase invoices', 'update purchase invoices']}>
                                            <PurchaseinvoicesEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="purchase_invoices/create" 
                                    element={
                                        <ProtectedRoute permissions={['create purchase invoices']}>
                                            <PurchaseinvoicesCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="purchase_invoices" 
                                    element={
                                        <ProtectedRoute permissions={['view purchase invoices']}>
                                            <Purchaseinvoices />
                                        </ProtectedRoute>
                                    } 
                                />
                                {/* End Purchase Routes */}



                                {/* Sales Routes */}
                                <Route path="production_charges" 
                                    element={
                                        <ProtectedRoute permissions={['view production charges', 'create production charges', 'update production charges']}>
                                            <Productioncharges />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="tailors" 
                                    element={
                                        <ProtectedRoute permissions={['view tailors', 'create tailors', 'update tailors']}>
                                            <Tailors />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="cutting_masters" 
                                    element={
                                        <ProtectedRoute permissions={['view cutting masters']}>
                                            <Cuttingmasters />
                                        </ProtectedRoute>
                                    } 
                                />

                                <Route path="job_enquiries" 
                                    element={
                                        <ProtectedRoute permissions={['view job orders', 'view job order lpos']}>
                                            <Jobenquiries />
                                        </ProtectedRoute>
                                    } 
                                />

                                <Route path="job_orders/view/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view job orders']}>
                                            <JobordersView />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="job_orders/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view job orders', 'update job orders']}>
                                            <JobordersEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="job_orders/create" 
                                    element={
                                        <ProtectedRoute permissions={['create job orders']}>
                                            <JobordersCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="job_orders" 
                                    element={
                                        <ProtectedRoute permissions={['view job orders']}>
                                            <Joborders />
                                        </ProtectedRoute>
                                    } 
                                />


                                <Route path="job_order_lpos/view/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view job order lpos']}>
                                            <JoborderlposView />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="job_order_lpos/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view job order lpos', 'update job order lpos']}>
                                            <JoborderlposEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="job_order_lpos/create" 
                                    element={
                                        <ProtectedRoute permissions={['create job order lpos']}>
                                            <JoborderlposCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="job_order_lpos/file/*" 
                                    element={
                                        <ProtectedRoute permissions={['view job order lpos']}>
                                            <JoborderlposFileViewer />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="job_order_lpos" 
                                    element={
                                        <ProtectedRoute permissions={['view job order lpos']}>
                                            <Joborderlpos />
                                        </ProtectedRoute>
                                    } 
                                />

                                <Route path="stock_issues/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['update stock issues']}>
                                            <StockissuesEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="stock_issues/create" 
                                    element={
                                        <ProtectedRoute permissions={['create stock issues']}>
                                            <StockissuesCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="stock_issues" 
                                    element={
                                        <ProtectedRoute permissions={['view stock issues']}>
                                            <Stockissues />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="stock_adjustments" 
                                    element={
                                        <ProtectedRoute permissions={['view stock adjustments']}>
                                            <Stockadjustments />
                                        </ProtectedRoute>
                                    } 
                                />


                                <Route path="daily_productions" 
                                    element={
                                        <ProtectedRoute permissions={['view daily productions']}>
                                            <Dailyproductions />
                                        </ProtectedRoute>
                                    } 
                                />

                                <Route path="produced_items" 
                                    element={
                                        <ProtectedRoute permissions={['view produced items']}>
                                            <Produceditems />
                                        </ProtectedRoute>
                                    } 
                                />

                                <Route path="job_costings/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view job costings', 'update job costings']}>
                                            <JobcostingsEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="job_costings/create" 
                                    element={
                                        <ProtectedRoute permissions={['create job costings']}>
                                            <JobcostingsCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="job_costings" 
                                    element={
                                        <ProtectedRoute permissions={['view job costings']}>
                                            <Jobcostings />
                                        </ProtectedRoute>
                                    } 
                                />


                                <Route path="cash_memos/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view cash memos', 'update cash memos']}>
                                            <CashmemosEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="cash_memos/create" 
                                    element={
                                        <ProtectedRoute permissions={['create cash memos']}>
                                            <CashmemosCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="cash_memos/view/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view cash memos']}>
                                            <CashmemosView />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="cash_memos" 
                                    element={
                                        <ProtectedRoute permissions={['view cash memos']}>
                                            <Cashmemos />
                                        </ProtectedRoute>
                                    } 
                                />

                                <Route path="cash_memo_directs/view/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view cash memo directs']}>
                                            <CashmemodirectsView />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="cash_memo_directs/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view cash memo directs', 'update cash memo directs']}>
                                            <CashmemodirectsEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="cash_memo_directs/create" 
                                    element={
                                        <ProtectedRoute permissions={['create cash memo directs']}>
                                            <CashmemodirectsCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="cash_memo_directs" 
                                    element={
                                        <ProtectedRoute permissions={['view cash memo directs']}>
                                            <Cashmemodirects />
                                        </ProtectedRoute>
                                    } 
                                />



                                <Route path="delivery_notes/view/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view delivery notes']}>
                                            <DeliverynotesView />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="delivery_notes/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view delivery notes', 'update delivery notes']}>
                                            <DeliverynotesEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="delivery_notes/create" 
                                    element={
                                        <ProtectedRoute permissions={['create delivery notes']}>
                                            <DeliverynotesCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="delivery_notes" 
                                    element={
                                        <ProtectedRoute permissions={['view delivery notes']}>
                                            <Deliverynotes />
                                        </ProtectedRoute>
                                    } 
                                />


                                <Route path="sale_invoices/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view sale invoices', 'update sale invoices']}>
                                            <SaleinvoicesEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="sale_invoices/view/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view sale invoices']}>
                                            <SaleinvoicesView />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="sale_invoices/create" 
                                    element={
                                        <ProtectedRoute permissions={['create sale invoices']}>
                                            <SaleinvoicesCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="sale_invoices" 
                                    element={
                                        <ProtectedRoute permissions={['view sale invoices']}>
                                            <Saleinvoices />
                                        </ProtectedRoute>
                                    } 
                                />


                                
                                <Route path="cash_receipts/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['update cash receipts']}>
                                            <CashreceiptsEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="cash_receipts/create" 
                                    element={
                                        <ProtectedRoute permissions={['update cash receipts']}>
                                            <CashreceiptsCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="cash_receipts" 
                                    element={
                                        <ProtectedRoute permissions={['view cash receipts', 'update cash receipts']}>
                                            <Cashreceipts />
                                        </ProtectedRoute>
                                    } 
                                />
                                {/* End Sale Routes */}


                                {/* Customers Routes */}
                                <Route path="customers/edit/:id" 
                                    element={
                                        <ProtectedRoute permissions={['view customers', 'update customers']}>
                                            <CustomersEdit />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="customers/create" 
                                    element={
                                        <ProtectedRoute permissions={['create customers']}>
                                            <CustomersCreate />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="customers" 
                                    element={
                                        <ProtectedRoute permissions={['view customers']}>
                                            <Customers />
                                        </ProtectedRoute>
                                    } 
                                />
                                {/* End Customers Routes */}



                                {/* Report Routes */}
                                <Route path="report-purchase-register" 
                                    element={
                                        <ProtectedRoute permissions={['report purchase register']}>
                                            <Reportpurchaseregisters />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-order-status" 
                                    element={
                                        <ProtectedRoute permissions={['report joborder status']}>
                                            <Reportorderstatuses />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-item-production" 
                                    element={
                                        <ProtectedRoute permissions={['report item production']}>
                                            <Reportitemproductions />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-item-production-costing" 
                                    element={
                                        <ProtectedRoute permissions={['report item production costing']}>
                                            <Reportitemproductioncostings />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-tailor-work" 
                                    element={
                                        <ProtectedRoute permissions={['report tailor work']}>
                                            <Reporttailorworks />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-job-order-customer-location" 
                                    element={
                                        <ProtectedRoute permissions={['report joborder customer location']}>
                                            <Reportjobordercustomerlocations />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-job-order" 
                                    element={
                                        <ProtectedRoute permissions={['report joborder register']}>
                                            <Reportjoborders />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-delivery-note" 
                                    element={
                                        <ProtectedRoute permissions={['report delivery note register']}>
                                            <Reportdeliverynotes />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-stock-ledger" 
                                    element={
                                        <ProtectedRoute permissions={['report stock ledger']}>
                                            <Reportstockledgers />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-item-ledger" 
                                    element={
                                        <ProtectedRoute permissions={['report item ledger']}>
                                            <Reportitemledgers />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-sales" 
                                    element={
                                        <ProtectedRoute permissions={['report sales']}>
                                            <Reportsales />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="report-daily-transactions" 
                                    element={
                                        <ProtectedRoute permissions={['report daily transactions']}>
                                            <Reportdailytransactions />
                                        </ProtectedRoute>
                                    } 
                                />
                                {/* End Report Routes */}



                                {/* Settings Routes */}
                                <Route path="currencies" 
                                    element={
                                        <ProtectedRoute permissions={['view currencies','update currencies']}>
                                            <Currencies />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="locations" 
                                    element={
                                        <ProtectedRoute permissions={['view locations','update locations']}>
                                            <Locations />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="customer_locations" 
                                    element={
                                        <ProtectedRoute permissions={['view locations','update locations']}>
                                            <Customerlocations />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="measurement_units" 
                                    element={
                                        <ProtectedRoute permissions={['view mesurment units','update mesurment units']}>
                                            <Measurementunits />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="posting_groups" 
                                    element={
                                        <ProtectedRoute permissions={['view posting groups','update posting groups']}>
                                            <Postinggroups />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="vat_groups" 
                                    element={
                                        <ProtectedRoute permissions={['view vat groups','update vat groups']}>
                                            <Vatgroups />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="general_settings" 
                                    element={
                                        <ProtectedRoute permissions={['view settings']}>
                                            <GeneralSettings />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route path="xero_settings" 
                                    element={
                                        <ProtectedRoute permissions={['view xero settings','update xero settings']}>
                                            <XeroSettings />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route 
                                    path="admin/roles" 
                                    element={
                                        <ProtectedRoute permissions={['view roles','update roles']}>
                                            <Adminroles />
                                        </ProtectedRoute>
                                    } 
                                />
                                <Route 
                                    path="admin/users" 
                                    element={
                                        <ProtectedRoute permissions={['view users','update users']}>
                                            <Adminusers />
                                        </ProtectedRoute>
                                    } 
                                />

                                <Route path="xero/redirect" element={<XeroRedirect />} />
                                <Route
                                    path="zoho_settings"
                                    element={
                                        <ProtectedRoute permissions={['view zoho settings', 'update zoho settings']}>
                                            <ZohoSettings />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route path="zoho/redirect" element={<ZohoRedirect />} />
                                <Route path="profile/edit/:id" element={<ProfilesEdit />} />
                            </Route>
                        </Routes>
                    </SecondarySidebarProvider>
                </SidebarProvider>
            </Router>
        </SplashProvider>
    );
};

export default App;
